import { priceSystem } from '@/api/index'

export function GetSendAreaPrice (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/GetSendAreaPrice',
    data,
    iSFromData: true
  })
}
export function GetSendStartPrice (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/GetSendStartPrice' + extendUrl,
    data,
    iSFromData: true
  })
}
export function priceSystemAdd (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/add' + extendUrl,
    data,
    iSFromData: true
  })
}

export function AddPriceRange (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/AddPriceRange',
    data
  })
}
export function DeletePriceRange (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/DeletePriceRange',
    data
  })
}
export function UpdateRangeMinValue (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/UpdateRangeMinValue',
    data
  })
}
export function DeleteDeliveryCharge (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/DeleteDeliveryCharge',
    data
    // iSFromData: true
  })
}
export function DeleteDeliveryCharge3 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/DeleteDeliveryCharge3',
    data
  })
}
export function DeleteDeliveryCharge78633 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/DeleteDeliveryCharge78633',
    data
  })
}
export function DeleteDeliveryCharge86250 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/DeleteDeliveryCharge86250',
    data
  })
}
export function InitCarriageTemplateData (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/InitCarriageTemplateData',
    data
  })
}
export function SaveDeliveryData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveDeliveryData' + extendUrl,
    data
  })
}
export function SaveCarriageData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData' + extendUrl,
    data
  })
}

export function SaveCarriageData2 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData2',
    data
  })
}
export function SaveDeliveryData86250 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData2',
    data
  })
}
export function SaveSafeData (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveSafeData',
    data
  })
}
export function SaveSendData (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveSendData',
    data
  })
}
export function SaveJincangData79710 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveJincangData79710',
    data
  })
}
export function SaveCarriageData_76955 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_76955',
    data
  })
}
export function SaveCarriageData_80799 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_80799',
    data
  })
}
export function SaveCarriageData_81930 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_81930',
    data
  })
}
export function SaveCarriageData_96209 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_96209',
    data
  })
}
export function SaveCarriageData_81003 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_81003',
    data
  })
}
export function SaveCarriageData_82622 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_82622',
    data
  })
}
export function SaveCarriageData_79358 (data: any) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_79358',
    data
  })
}

export function SaveCarriageData_80028 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveCarriageData_80028' + extendUrl,
    data
  })
}
export function SaveData_GroundLine (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveData_GroundLine' + extendUrl,
    data
  })
}
export function SaveData_Other (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveData_Other' + extendUrl,
    data
  })
}
export function SaveDataComm (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveDataComm' + extendUrl,
    data
  })
}
export function SaveLinePriceData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveLinePriceData' + extendUrl,
    data
  })
}
export function SaveItemPriceData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveItemPriceData' + extendUrl,
    data
  })
}
export function SaveFyAddressData (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveFyAddressData' + extendUrl,
    data
  })
}

export function SaveEditPrice (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice78633 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice78633' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice79710 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice79710' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice80028 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice80028' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice81003 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice81003' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice81930 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice81930' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice79323 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice79323' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice82622 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice82622' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice79358 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice79358' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPriceComm (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPriceComm' + extendUrl,
    data,
    iSFromData: true
  })
}
export function SaveEditPrice86250 (data: any, params: any) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditPrice86250' + extendUrl,
    data,
    iSFromData: true
  })
}
